import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./context/AuthContext";
import { BrowserRouter as Router } from "react-router-dom";

// Redux imports
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./redux/store";
import AppThemeProvider from "./theme/AppThemeProvider";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <AppThemeProvider>
        <Router>
          <AuthProvider>
            {/* <React.StrictMode> */}
            <App />
            {/* </React.StrictMode> */}
          </AuthProvider>
        </Router>
      </AppThemeProvider>
    </PersistGate>
  </Provider>
);

reportWebVitals();
